import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import esCommon from './locales/es/common.json';
import esSettings from './locales/es/settings.json';
import esBilling from './locales/es/billing.json';
import esCustomerTabs from './locales/es/customerTabs.json';
import enCommon from './locales/en/common.json';
import enSettings from './locales/en/settings.json';
import enBilling from './locales/en/billing.json';
import enCustomerTabs from './locales/en/customerTabs.json';

const resources = {
  es: {
    common: esCommon,
    settings: esSettings,
    billing: esBilling,
    customerTabs: esCustomerTabs,
  },
  en: {
    common: enCommon,
    settings: enSettings,
    billing: enBilling,
    customerTabs: enCustomerTabs,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: ['common', 'settings', 'billing', 'customerTabs'],

    detection: {
      // Don't use built-in localStorage detection since we store JSON format
      // Custom detection is handled below
      order: ['navigator'],
      caches: [],
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false, // Avoid suspense for SSR compatibility
    },
  });

const syncDocumentLanguage = (language) => {
  if (typeof document === 'undefined') return;
  const normalizedLanguage = language?.startsWith('en') ? 'en' : 'es';
  document.documentElement.lang = normalizedLanguage;
  document.documentElement.dir = 'ltr';
};

i18n.on('languageChanged', syncDocumentLanguage);
syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);

// Custom language detection from userPreferences localStorage
// Wrapped in try-catch to handle SSR and initialization errors
try {
  if (typeof window !== 'undefined' && window.localStorage) {
    const userPrefs = localStorage.getItem('userPreferences');
    if (userPrefs) {
      // Validate JSON format before parsing
      if (!userPrefs.startsWith('{')) {
        localStorage.removeItem('userPreferences');
      } else {
        const prefs = JSON.parse(userPrefs);
        if (prefs.language && ['es', 'en'].includes(prefs.language)) {
          i18n.changeLanguage(prefs.language);
        }
      }
    }
  }
} catch (e) {
  // Clear invalid preferences on parse error
  try {
    localStorage.removeItem('userPreferences');
  } catch (removeError) {
    // Ignore removal errors
  }
}

export default i18n;
